import { render, staticRenderFns } from "./AccountGroupList.vue?vue&type=template&id=2edc3a6b&scoped=true&"
import script from "./AccountGroupList.vue?vue&type=script&lang=js&"
export * from "./AccountGroupList.vue?vue&type=script&lang=js&"
import style0 from "./AccountGroupList.vue?vue&type=style&index=0&id=2edc3a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc3a6b",
  null
  
)

export default component.exports